import React, { useState } from 'react'
import { Grid, Row, Panel, Table, Message, IconButton, Icon } from 'rsuite'

export default function LearningCenterView(props) {
  const { Column, HeaderCell, Cell, Pagination } = Table

  const { schema, values, isError } = props

  return (
    <Panel shaded header={schema.header} collapsible defaultExpanded>
      {/* {isError && <Message showIcon type="error" description={typeof isError === 'string' ? isError : 'ไม่สำเร็จ'} />} */}
      <Row>
        <Panel bodyFill>
          <Grid fluid>
            <Table wordWrap autoHeight data={values || []} cellBordered>
              <Column width={500} flexGrow={1}>
                <HeaderCell>ชื่อแหล่งเรียนรู้</HeaderCell>
                <Cell dataKey="name" />
              </Column>

              <Column width={350} flexGrow={1}>
                <HeaderCell>ที่อยู่</HeaderCell>
                <Cell dataKey="address" />
              </Column>

              <Column width={350} flexGrow={1}>
                <HeaderCell>กลุ่มเป้าหมายที่อยากให้มาเรียนรู้</HeaderCell>
                <Cell dataKey="target" />
              </Column>
            </Table>
          </Grid>
        </Panel>
      </Row>
      <Row style={{ textAlign: 'right' }}>
        <IconButton
          appearance="ghost"
          className="rs-btn-ghost-info"
          icon={<Icon icon="external-link" className={'bt-gost-icon-radius-info'} />}
          onClick={() =>
            window.open('https://iam.thaihealth.or.th/Learning-Manage.html#/?lang=th', '_blank')
          }
        >
          ไปยังระบบ I Am เพื่อเพิ่มแหล่งเรียนรู้
        </IconButton>
      </Row>
    </Panel>
  )
}
